import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Unauthorized from "../general/Unauthorized";
import Loading from "../general/Loading";

function MenuLaboratorio() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a laboratorio
        const tienePermiso = userdata.up && userdata.up.includes('verLaboratorio');

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);
        setLoggedIn(true);
    }, []);

    // 🔒 PROTECCIÓN DE RUTA
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }

    return (
        <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
            <Header />
            <Aside activelink="laboratory" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left mb-0">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item active">Laboratorio</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-end">
                            <div className="col-md-8">
                                <div className="dash-wrap">
                                    <h1 className="dash-title">Laboratorio</h1>
                                    <p className="dash-subtitle mb-0">Órdenes, tipos de trabajo y materiales</p>
                                </div>
                            </div>
                            <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link to="/home" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                    <i className="fas fa-arrow-left mr-1"></i> Volver al inicio
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="dash-card mb-4">
                            <div className="dash-card-header">
                                <h2 className="dash-card-title">
                                    <span className="title-icon" aria-hidden="true"><i className="fas fa-flask"></i></span>
                                    Opciones
                                </h2>
                            </div>
                            <div className="dash-card-body">
                                <div className="quick-grid">
                                    <Link to="/crear-orden-laboratorio" className="quick-card">
                                        <div className="quick-ico"><i className="fas fa-plus"></i></div>
                                        <p className="quick-title">Nueva orden</p>
                                        <p className="quick-sub">Crear orden de laboratorio</p>
                                    </Link>

                                    <Link to="/listado-ordenes-laboratorio" className="quick-card">
                                        <div className="quick-ico"><i className="fas fa-list"></i></div>
                                        <p className="quick-title">Listado de órdenes</p>
                                        <p className="quick-sub">Seguimiento y estados</p>
                                    </Link>

                                    <Link to="/tipos-trabajo-laboratorio" className="quick-card">
                                        <div className="quick-ico"><i className="fas fa-cogs"></i></div>
                                        <p className="quick-title">Tipos de trabajo</p>
                                        <p className="quick-sub">Administración de catálogo</p>
                                    </Link>

                                    <Link to="/materiales-laboratorio" className="quick-card">
                                        <div className="quick-ico"><i className="fas fa-cubes"></i></div>
                                        <p className="quick-title">Materiales</p>
                                        <p className="quick-sub">Parametrización de insumos</p>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="dash-card mb-4">
                            <div className="dash-card-header">
                                <h2 className="dash-card-title">
                                    <span className="title-icon" aria-hidden="true"><i className="fas fa-info-circle"></i></span>
                                    Información del módulo
                                </h2>
                            </div>
                            <div className="dash-card-body">
                                <p className="mb-2" style={{ fontWeight: 700, color: '#323a45' }}>Gestión de órdenes de laboratorio</p>
                                <ul className="mb-0 pl-3" style={{ color: '#8c8c8c', fontSize: '0.85rem', lineHeight: 1.55 }}>
                                    <li>Crear órdenes con múltiples trabajos</li>
                                    <li>Asignar profesionales responsables</li>
                                    <li>Registrar procesos por trabajo</li>
                                    <li>Estados: pendiente, en proceso, completada, entregada</li>
                                    <li>Control de fechas de recepción y entrega estimada</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default MenuLaboratorio;
